/*---------------------------------------------------------------------------------
 *
 *	This component acts as a container for all regression components
 *  including the PointDrawer, Graph, and OrderChanger.
 *	It also handles the `order/degree` of the polynomial model that is changed via the
 *  <OrderChanger/> component.
 *
 * --------------------------------------------------------------------------------
 */

import React from "react";
import Graph from "./Graph";
import PointDrawer from "./PointDrawer";
import OrderChanger from "./OrderChanger";

interface MyProps {}

interface MyState {
  x_array: number[];
  y_array: number[];
  order_graph_1: number;
}

class RegressionItemsContainer extends React.Component<MyProps, MyState> {
  color_graph_1: string;
  constructor(props: MyProps) {
    super(props);
    this.state = {
      x_array: [],
      y_array: [],
      order_graph_1: 1,
    };
    this.color_graph_1 = "rgb(255,0,0)";
  }

  addCoord(coord: { x: number, y: number }) {
    const new_x_array = this.state.x_array.concat(coord.x);
    const new_y_array = this.state.y_array.concat(coord.y);
    this.setState({
      x_array: new_x_array,
      y_array: new_y_array,
    });
  }

  resetCoords() {
    this.setState({ x_array: [], y_array: [], order_graph_1: 1 });
  }

  setOrders(orders: number[]) {
    this.setState({
      order_graph_1: orders[0],
    });
  }

  render() {
    return (
      <div
        style={{
          width: "100vw",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <div>
          <div style={{ paddingLeft: "100px" }}>
            <PointDrawer
              addCoord={this.addCoord.bind(this)}
              resetCoords={this.resetCoords.bind(this)}
            />
            <div style={{ paddingBottom: "50px" }}>
              <OrderChanger
                order_graph_1={this.state.order_graph_1}
                setOrders={(orders: any) => this.setState(orders)}
              />
            </div>
          </div>
        </div>
        <div style={{ paddingLeft: "70px", paddingTop: "50px" }}>
          <Graph
            x={this.state.x_array}
            y={this.state.y_array}
            order={this.state.order_graph_1}
            color={this.color_graph_1}
          />
        </div>
      </div>
    );
  }
}

export default RegressionItemsContainer;
